import React from 'react'

import { Spinner } from '@acorns/web-components'

import {
  SpinnerContainer,
  VerificationBody,
  VerificationContainer,
  VerificationHeader,
} from './styled-components'

export const VerifyingLoaderScreen = () => {
  return (
    <VerificationContainer>
      <SpinnerContainer>
        <Spinner width={35} height={35} />
      </SpinnerContainer>
      <VerificationHeader> Verifying information</VerificationHeader>
      <VerificationBody>This could take a few seconds.</VerificationBody>
    </VerificationContainer>
  )
}
